module.exports = __webpack_public_path__ + "static/img/G1.29af3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/G1.png
// module id = /140
// module chunks = 0